import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentText = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3333 18.9557H6.66667C3.625 18.9557 1.875 17.2057 1.875 14.1641V5.83073C1.875 2.78906 3.625 1.03906 6.66667 1.03906H13.3333C16.375 1.03906 18.125 2.78906 18.125 5.83073V14.1641C18.125 17.2057 16.375 18.9557 13.3333 18.9557ZM6.66667 2.28906C4.28333 2.28906 3.125 3.4474 3.125 5.83073V14.1641C3.125 16.5474 4.28333 17.7057 6.66667 17.7057H13.3333C15.7167 17.7057 16.875 16.5474 16.875 14.1641V5.83073C16.875 3.4474 15.7167 2.28906 13.3333 2.28906H6.66667Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4154 7.70833H13.7487C12.482 7.70833 11.457 6.68333 11.457 5.41667V3.75C11.457 3.40833 11.7404 3.125 12.082 3.125C12.4237 3.125 12.707 3.40833 12.707 3.75V5.41667C12.707 5.99167 13.1737 6.45833 13.7487 6.45833H15.4154C15.757 6.45833 16.0404 6.74167 16.0404 7.08333C16.0404 7.425 15.757 7.70833 15.4154 7.70833Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0013 11.4609H6.66797C6.3263 11.4609 6.04297 11.1776 6.04297 10.8359C6.04297 10.4943 6.3263 10.2109 6.66797 10.2109H10.0013C10.343 10.2109 10.6263 10.4943 10.6263 10.8359C10.6263 11.1776 10.343 11.4609 10.0013 11.4609Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3346 14.7891H6.66797C6.3263 14.7891 6.04297 14.5057 6.04297 14.1641C6.04297 13.8224 6.3263 13.5391 6.66797 13.5391H13.3346C13.6763 13.5391 13.9596 13.8224 13.9596 14.1641C13.9596 14.5057 13.6763 14.7891 13.3346 14.7891Z",
			fill: "white"
		})
	]
});
export default SvgDocumentText;
